export const getClassName = (index, activeStep) => {
    if (index < activeStep) {
        return "previous"
    } else if (index === activeStep) {
        return ""
    } else {
        return "next"
    }
}